import { createFilterOptions } from "@mui/base";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import { useEffect, useState } from "react";

import { ApiService } from "../../constants/ApiService";
import { HttpService } from "../../constants/HTTPService";
import { IAutoComplete } from "../../interfaces/IAutoComplete";

const getAutoCompleteBinusian = async (search: string) => {
  const objData: IAutoComplete[] = [];

  const data = HttpService.post(
    ApiService.apiHc.getAutoCompleteBinusian,
    JSON.stringify({
      AutoCompleteSearch: search,
    })
  );
  const dataAPI = (await data).data;
  if (dataAPI.resultCode === 200) {
    const jsonParse = JSON.parse(dataAPI.data);
    jsonParse.data.forEach((datas: any) => {
      objData.push({
        binusianIDEmail: `${datas.email_Edu}~${datas.binusianID}`,
        name: `${datas.email_Edu} - ${datas.name}`,
      });
    });
  }

  return objData;
};

export default function AutocompleteComponent({
  propsData,
  name,
  optional = false,
  isCommentForm = false,
}) {
  const { handleChange, handleBlur, values } = propsData;
  const [open, setOpen] = useState(false);
  const [changeText, setChangetText] = useState("");
  const [options, setOptions] = useState<readonly IAutoComplete[]>([]);
  const [validateOption, setValidateOption] = useState("Please Type 3 Text");

  const sendDataToParent = (event) => {
    handleChange(event);
  };

  const handleOnBlur = (event) => {
    handleBlur(event);
  };

  const handleClickChange = (event, newValue, reason) => {
    if (reason == "clear" && event.type !== "change" && optional) {
      values[name] = {
        binusianIDEmail: "Tidak ada~Tidak ada",
        name: "Tidak ada",
      };
      if (isCommentForm) {
        handleChange({ target: { value: values[name] } });
      }
      return;
    }

    if (newValue != null) {
      values[name] = {
        binusianIDEmail: newValue.binusianIDEmail,
        name: newValue.name,
      };
    } else {
      values[name] = null;
    }
    if (isCommentForm) {
      handleChange({ target: { value: values[name] } });
    }
  };

  const handleTextChange = (event, newValue) => {
    setChangetText(newValue);
  };

  const filterOptions = (opt, { inputValue }) => {
    // Filter options based on the input value
    const filteredOptions = opt.filter((option) =>
      option.name.toLowerCase().includes(inputValue.toLowerCase())
    );

    // If the filtered options do not include the "Tidak ada" option, add it
    if (
      !filteredOptions.some((option) => option.name === "Tidak ada") &&
      changeText.length > 2 &&
      filteredOptions.length > 0
    ) {
      filteredOptions.unshift({
        name: "Tidak ada",
        binusianIDEmail: "Tidak ada~Tidak ada",
      });
    }

    return filteredOptions;
  };

  useEffect(() => {
    (async () => {
      setValidateOption("Please Type 3 Text");
      if (changeText.length > 2) {
        const dataStaff = await getAutoCompleteBinusian(changeText);
        if (optional) {
          setOptions([
            { name: "Tidak ada", binusianIDEmail: "Tidak ada~Tidak ada" },
            ...dataStaff,
          ]);
        } else {
          setOptions(dataStaff);
        }
        if (dataStaff.length === 0) {
          setValidateOption("Data Not Found");
        }
      } else {
        setOptions([]);
      }
    })();
  }, [changeText]);

  useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <Autocomplete
      sx={{ width: isCommentForm ? "95%" : "100%" }}
      disableClearable={
        optional
          ? values[name]?.binusianIDEmail == "Tidak ada~Tidak ada"
          : false
      }
      open={open}
      onOpen={() => {
        setOpen(true);
        if (
          values[name]?.binusianIDEmail == "Tidak ada~Tidak ada" &&
          optional
        ) {
          setChangetText("");
        }
      }}
      onClose={(_, reason) => {
        setOpen(false);
        if (
          reason !== "selectOption" &&
          values[name]?.binusianIDEmail == "Tidak ada~Tidak ada" &&
          optional
        ) {
          handleClickChange(
            null,
            { name: "Tidak ada", binusianIDEmail: "Tidak ada~Tidak ada" },
            reason
          );
        }
      }}
      inputValue={changeText}
      isOptionEqualToValue={(option, value) =>
        option.binusianIDEmail === (value ? value.binusianIDEmail : value)
      }
      getOptionLabel={(option) => option.name}
      options={options}
      noOptionsText={validateOption}
      onChange={handleClickChange}
      onInputChange={handleTextChange}
      value={values[name]}
      filterOptions={optional ? filterOptions : createFilterOptions()}
      renderInput={(params) => (
        <TextField
          onChange={sendDataToParent}
          onBlur={handleOnBlur}
          {...params}
          InputProps={{
            ...params.InputProps,
            endAdornment: (
              <>
                {open && changeText.length > 0 ? (
                  <CircularProgress color="inherit" size={15} />
                ) : null}
                {params.InputProps.endAdornment}
              </>
            ),
          }}
        />
      )}
    />
  );
}
